import React, { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "./style.css";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import {
  adminEditStatus,
  convertBookingDateFormat,
  convertToGMT,
  getBookingFormatedDateValue,
  getBookingFormatedValue,
  getFormattedDateTime,
  getTimeDistanceDifference,
  handleRedirectUrl,
  isInvalidValue,
  getPaymentDisplayLabel,
  calcFareValues,
} from "../../../utils/Functions";
import LocationIcon from "../../../assets/location.svg";
import userIcon from "../../../assets/user.svg";
import driverIcon from "../../../assets/driverIcon.svg";
import contactIcon from "../../../assets/contactcard.svg";
import calendarIcon from "../../../assets/calendar.svg";
import DriverIcon from "../../../assets/drivericon.jpg";
import CarIcon from "../../../assets/carIcon.png";
import VerifiedIcon from "../../../assets/verifiedIcon.png";
import { CITY_ID, delayData, FARE_ADVANCE_COMMISSION_PERCENT, FARE_PLATFORM_FEE_PERCENT, FARE_GST_PERCENT } from "../../../utils/common.data";
import {
  checkSeatAvailabilityCategory,
  getCityData,
  getEstimateFareByData,
  getUserDetail,
  postSaveMTripCategory,
  postSaveTrip,
  postSaveTripWithTrans,
  postUpdateTrip,
  sendBookingSMS,
  validatePromoCode,
} from "../../../utils/api.functions";
import { useBoardingDropping } from "../../../context/BoardingDroppingContext";
import Loader from "../../loader";
import WalletPopup from "../../WalletPopup";
import { bookingInstructionData } from "../../../utils/data";

const AdminPassengerDetail = ({
  busSelect,
  seatDetail,
  amountVal,
  handleFormClose,
  boardingSelection,
  droppingSelection,
  tripDetail
}) => {
  const params = useParams()
  const apikey = sessionStorage.getItem("key");
  const userid = sessionStorage.getItem("userid");
  const [searchDetail, setSearchDetail] = useState({});
  const [view, setView] = useState(0);
  const [companyId, setCompanyId] = useState(1);
  const [err, setErr] = useState({});
  const [check, setCheck] = useState(tripDetail ? true : false);
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState({
    email: "",
    mobile: "",
    country: "",
  });
  const [promoCode, setPromoCode] = useState(isInvalidValue(tripDetail?.trip_promo_code));
  const [applypromocode, setApplypromocode] = useState(isInvalidValue(tripDetail?.trip_promo_code));
  // const [paymentMethod, setPaymentMethod] = useState(isInvalidValue(tripDetail?.trip_pay_mode));
  const [paymentMethod, setPaymentMethod] = useState('Cash');
  const [promoId, setPromoId] = useState(isInvalidValue(tripDetail?.promo_id));
  const [paymentStatus, setPaymentStatus] = useState(isInvalidValue(tripDetail?.trip_pay_status));
  const [tripStatus, setTripStatus] = useState(isInvalidValue(tripDetail?.trip_status));

  const [formData, setFormData] = useState(
    seatDetail.map((val) => ({
      id: val.id,
      seat_id: val.seat_id,
      seat_type: val?.seat_type,
      name: val?.name ? val?.name : "",
      gender: val?.gender ? val?.gender : "",
      age: val?.age ? val?.age : "18",
      errors: {
        name: "",
        gender: "",
        age: ""
      },
    }))
  );

  const [showPopup, setShowPopup] = useState(false);
  const [mTripID, setMtripID] = useState("");
  const [citydrop, setCityDrop] = useState([]);
  const [cityTax, setCityTax] = useState(FARE_GST_PERCENT);  const [walletPopup, setWalletPopup] = useState(false);

  // Booking Main State
  const [estimPriceList, setEstimPriceList] = useState(null);
  const [totalFare, setTotalFare] = useState(amountVal);

  const [bookingSummary, setBookingSummary] = useState({
    trip_base_fare: 0,
    tax: 0,
    totalFare: amountVal,
    trip_promo_amt: 0,
    promo_code: "",
    promo_id: 0,
    trip_comp_commision: 0,
    special_fare: 0
  });
  const [totalPriceEstimated, setTotalPriceEstimated] = useState(0);

    useEffect(()=>{
      setCompanyId(busSelect?.driver?.company_id || 1)
    },[busSelect])

  useEffect(() => {
    if (seatDetail) {
      setFormData(seatDetail.map((val) => ({
        id: val.id,
        seat_id: val.seat_id,
        seat_type: val?.seat_type,
        name: val?.name ? val?.name : "",
        gender: val?.gender ? val?.gender : "",
        age: val?.age ? val?.age : "18",
        errors: {
          name: "",
          gender: "",
          age: ""
        },
      })))
    }
  }, [seatDetail])

  useEffect(() => {
    const authData = sessionStorage.getItem("auth");
    if (authData) {
      try {
        const value = JSON.parse(authData);
        const tripDataValue = tripDetail?.customer_details ? tripDetail?.customer_details?.detail : null
        setDetail({
          ...detail,
          email: tripDataValue ? tripDataValue?.email : value?.email,
          mobile: tripDataValue ? tripDataValue?.mobile : `+${value?.c_code}${value?.phone}`,
          country: tripDataValue ? tripDataValue?.c_code : value?.countryid,
        });
        const updatedFormData = [...seatDetail.map((val) => ({
          id: val.id,
          seat_id: val.seat_id,
          seat_type: val?.seat_type,
          name: val?.name ? val?.name : "",
          gender: val?.gender ? val?.gender : "",
          age: val?.age ? val?.age : "18",
          errors: {
            name: "",
            gender: "",
            age: ""
          },
        }))];

        if (!params?.id) {
          updatedFormData[0]["name"] = value?.name;
        }

        setFormData(updatedFormData);
      } catch (error) {
        console.log("Auth Data", error);
      }
    }
  }, [seatDetail, tripDetail]);

  useEffect(() => {
    if (params?.id && tripDetail && adminEditStatus.includes(tripDetail?.trip_status)) {
      setView(1)
      setBookingSummary({
        trip_base_fare: tripDetail?.trip_base_fare,
        tax: tripDetail?.tax_amt,
        totalFare: tripDetail?.trip_pay_amount,
        trip_promo_amt: tripDetail?.trip_promo_amt,
        promo_code: tripDetail?.promo_code,
        promo_id: tripDetail?.promo_id,
        trip_comp_commision: tripDetail?.trip_comp_commision,
        special_fare: tripDetail?.extra_charges?.specialFarePrice
      });
    }
  }, [params, tripDetail])

  useEffect(() => {
    const searchData = sessionStorage.getItem("bookingdetails");
    if (searchData) {
      setSearchDetail(JSON.parse(searchData));
      
      if(parseInt(companyId) > 1 && !params?.id){
        fetchEstimateFareData();
        setPaymentMethod('Card')
      }
    }
  }, [seatDetail, companyId]);

  useEffect(() => {
    if (estimPriceList) {
      const est = estimPriceList[busSelect?.category_id];
      const isPremium = parseInt(companyId) > 1;
      const fareValues = calcFareValues(
        Number(est?.trip_base_fare) || 0,
        isPremium ? FARE_PLATFORM_FEE_PERCENT : 0,
        isPremium ? cityTax : 0
      );
      setBookingSummary({
        trip_base_fare: est?.trip_base_fare,
        tax: fareValues.gst,
        totalFare: Number(fareValues.totalFare) || Number(est?.trip_pay_amount) || 0,
        trip_promo_amt: estimPriceList[busSelect?.category_id]?.trip_promo_amt,
        promo_code: estimPriceList[busSelect?.category_id]?.promo_code,
        promo_id: estimPriceList[busSelect?.category_id]?.promo_id,
        trip_comp_commision: estimPriceList[busSelect?.category_id]?.trip_comp_commision,
        special_fare: estimPriceList[busSelect?.category_id]?.extra_charges?.specialFarePrice
      });
    }
  }, [estimPriceList, busSelect]);

  useEffect(() => {
    if (bookingSummary?.totalFare != null) {
      setTotalFare(bookingSummary.totalFare);
      setTotalPriceEstimated(bookingSummary.totalFare);
    }
  }, [bookingSummary]);

  const { razorpayKey, fetchRazorpayKeys, localisations } = useBoardingDropping();

  useEffect(() => {
    if (!razorpayKey) {
      fetchRazorpayKeys(); // Fetch data if not already available
    }
  }, [razorpayKey, fetchRazorpayKeys]);

  useEffect(() => {
    getCities();
    fetchRazorpayKeys(); // Fetch data if not already available
  }, []);

  useEffect(() => {
    getUserData();
    getCategoryMTrip()
  }, []);

  const getCities = async () => {
    try {
      const response = await getCityData({
        city_id: CITY_ID
      }, apikey);
      if (response.status === 200) {
        setCityDrop(response.data.response);
        const tax = Number(response.data.response?.[0]?.city_tax);
        if (tax > 0) setCityTax(tax);
      }
    } catch (error) {
      console.log("Error::", error);
    }
  };


  const getUserData = async () => {
    try {
      const response = await getUserDetail({
        user_id: userid,
      }, apikey);
      if (response.status === 200) {
        const value = response.data.resDecrypt.response;
        sessionStorage.setItem("wmt", value[0]?.u_wallet ? value[0]?.u_wallet : "0");
      }
    } catch (error) {
      console.log("User fetch ErrorError::", error);
    }
  };



  const getCategoryMTrip = async () => {
    try {
      const response = await postSaveMTripCategory({
        category_id: busSelect?.category_id,
        category_time: convertToGMT(new Date(busSelect?.departure))
      }, apikey);
      if (response.status === 200) {
        const value = response.data.resDecrypt.response;
        setMtripID(value)
      }
    } catch (error) {
      console.log("Create MTrip Error::", error);
    }
  };

  const handleInputChange = (e, index, field) => {
    const value = e.target.value;
    const updatedFormData = [...formData];
    updatedFormData[index][field] = value;
    updatedFormData[index].errors[field] = "";

    setFormData(updatedFormData);
  };

  const handleDetailChange = (e) => {
    setDetail({ ...detail, [e.target.name]: e.target.value });
    setErr({ ...err, [e.target.name]: "" });
  };

  const handleMobileChange = (e) => {
    let formattedPhone = formatPhoneNumberIntl(e.target.value).split(" ");
    let dataValue = {
      c_code: formattedPhone[0].replace("+", ""),
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    setDetail({ ...detail, [e.target.name]: e.target.value });
    setErr({ ...err, [e.target.name]: "" });
    if (!(dataValue?.u_phone?.length >= 8 && dataValue?.u_phone?.length <= 12)) {
      setErr({ ...err, [e.target.name]: "Mobile number must be between 8 to 12 digits." });
    }
  };

  const handlePromoChange = (e) => {
    setPromoCode(e.target.value);
  };

  const handleCheckTerms = (value) => {
    setCheck(value)
    setErr({ ...err, terms: '' })
  }

  const handleResetPromo = async () => {
    try {
      let data = {
        trip_from_loc: searchDetail?.boarding,
        trip_to_loc: searchDetail?.dropping,
        trip_date: convertToGMT(new Date(busSelect?.departure)),
        trip_hrs: getTimeDistanceDifference(
          new Date(busSelect?.departure),
          new Date(busSelect?.arrival)
        ),
        api_key: apikey,
        city_id: CITY_ID,
        user_id: userid,
        seats: seatDetail?.length,
        is_share: 0,
        polyline: "0",
        amount: amountVal,
      };

      const result = await getEstimateFareByData(data, apikey);
      if (result?.status === 200 && result.data.resDecrypt.response) {
        setEstimPriceList(result.data.resDecrypt.response);
        setApplypromocode('');
        setPromoCode('')
      }
    } catch (error) {
      console.log(`Check Reset Promo`, error)
    }
  }

  const handleApplyCoupon = async (e) => {
    e.preventDefault();
    if (!promoCode) {
      toast.dismiss();
      toast.error("Promo code is required");
      return;
    }
    if (promoCode) {
      if (promoCode == applypromocode) {
        toast.dismiss();
        toast.error("Promo code already applied.");
        return;
      }

      try {

        const params = {
          api_key: apikey,
          city_id: CITY_ID,
          // user_id: userid,
          amount: amountVal,
          promo_code: promoCode,
        };



        const checkPromo = await validatePromoCode(params, apikey)

        if (checkPromo?.status == 200) {

          let data = {
            trip_from_loc: searchDetail?.boarding,
            trip_to_loc: searchDetail?.dropping,
            trip_date: convertToGMT(new Date(busSelect?.departure)),
            trip_hrs: getTimeDistanceDifference(
              new Date(busSelect?.departure),
              new Date(busSelect?.arrival)
            ),
            api_key: apikey,
            city_id: CITY_ID,
            // user_id: userid,
            seats: seatDetail?.length,
            is_share: 0,
            polyline: "0",
            promo_code: promoCode,
            amount: amountVal,
          };

          const result = await getEstimateFareByData(data, apikey);
          if (result?.status === 200 && result.data.resDecrypt.response) {
            setEstimPriceList(result.data.resDecrypt.response);
            toast.dismiss();
            toast.success("Promo code applied successfully.");
            setApplypromocode(promoCode);
          } else {
            toast.dismiss();
            toast.error("Invalid Promo code");
          }

        }
      } catch (error) {
        toast.dismiss();
        toast.error("Invalid Promo code.");
      }
    }
  };

  const validateForm = (index) => {
    const updatedFormData = [...formData];
    const errors = updatedFormData[index].errors;

    // Validate Name
    if (!updatedFormData[index].name.trim()) {
      errors.name = "Name is required";
    } else {
      errors.name = "";
    }

    // Validate Gender
    if (!updatedFormData[index].gender) {
      errors.gender = "Gender is required";
    } else {
      errors.gender = "";
    }

    // Validate Age
    if (!updatedFormData[index].age.trim()) {
      errors.age = "Age is required";
    } else if (
      isNaN(updatedFormData[index].age) ||
      updatedFormData[index].age <= 0 ||
      updatedFormData[index].age < 0 ||
      updatedFormData[index].age > 120
    ) {
      errors.age = "Please enter a valid age";
    } else {
      errors.age = "";
    }

    setFormData(updatedFormData);

    // Return if there are any errors
    return !Object.values(errors).some((error) => error);
  };

  const handlePhoneView = (mobile) => {
    let formattedPhone = formatPhoneNumberIntl(mobile).split(" ");
    let dataValue = {
      c_code: formattedPhone[0],
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    return `${dataValue.c_code} ${dataValue.u_phone}`
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    getCities();
    let formattedPhone = formatPhoneNumberIntl(detail.mobile).split(" ");
    let dataValue = {
      c_code: formattedPhone[0].replace("+", ""),
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    const validationResult = validateFormData(
      detail.email,
      dataValue.u_phone,
      check
    );
    setErr(validationResult);
    let test = true;
    // Loop through seat details and check validation for each seat
    for (let index = 0; index < seatDetail.length; index++) {
      const isValid = validateForm(index);

      if (!isValid) {
        test = false;
      }
    }
    if (Object.keys(validationResult).length > 0) {
      test = false;
    }

    if (test && params?.id) {
      setView(1);
      return
    }

    if (test && !params?.id) {
      try {
        const data = {
          category_id: busSelect?.category_id,
          ...(mTripID && mTripID !== "" ? {} : { date:busSelect?.departure}),
          seats: seatDetail?.map((value) => value.seat_id),
          category_time: convertToGMT(new Date(busSelect?.departure)), m_trip_id: mTripID
        };
        const checkValue = await checkSeatAvailabilityCategory(data, apikey);

        if (checkValue.status == 200) {

      if(parseInt(companyId) > 1){
        await fetchEstimateFareData();
      }


          setView(1);
          // console.log({ seatDetail, detail, promoCode, dataValue });
        }
      } catch (error) {
        toast.dismiss();
        toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');

        setTimeout(() => {
          window?.location?.reload()
        }, delayData.adminFormDelay);
      }
    }
  };

  const handleViewChange = (val) => {
    setView(val);
  };


  const handleBoardingView = (id, busSelect) => {
    //return busSelect?.boarding_points?.filter((point) => point.id == id);
    return [busSelect?.boarding_points[0]]
  };

  const handleDroppingView = (id, busSelect) => {
    //return busSelect?.dropping_points?.filter((point) => point.id == id);
    return [busSelect?.dropping_points[0]]
  };

  const handlePayButton = async () => {
    let test = true;
    for (let index = 0; index < seatDetail.length; index++) {
      const isValid = validateForm(index);

      if (!isValid) {
        test = false;
      }
    }
    if (!test) {
      setView(0)
      return
    }
    try {
      const data = {
        category_id: busSelect?.category_id,
        ...(mTripID && mTripID !== "" ? {} : { date: busSelect?.departure }),
        seats: seatDetail?.map((value) => value.seat_id),
        category_time: convertToGMT(new Date(busSelect?.departure)), m_trip_id: mTripID
      };
      const checkValue = await checkSeatAvailabilityCategory(data, apikey);

      if (checkValue.status == 200) {
        if (!paymentMethod) {
          setErr({ ...err, payment: 'Please Select Payment Method' })
          // handleCashMethod(null)
          return
        }
        if (paymentMethod.toUpperCase() == "CASH") {
          handleCashMethod(paymentMethod)
          return
        }

        if (paymentMethod.toUpperCase() == "WALLET") {
          handleWalletMethod(paymentMethod)
          return
        }
      }
    } catch (error) {
      toast.dismiss();
      console.error("Order Error", error);
      toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');

      setTimeout(() => {
        // handleRedirectUrl(
        //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
        //   "_self"
        // );
        window?.location?.reload()
      }, delayData.adminFormDelay);

    }
  };

  const handlePayButtonEdit = async () => {
    let test = true;
    for (let index = 0; index < seatDetail.length; index++) {
      const isValid = validateForm(index);

      if (!isValid) {
        test = false;
      }
    }
    if (!test) {
      setView(0)
      return
    }
    handleTripEditSave(paymentMethod)
  };

  const handleTripEditSave = async (payMethod) => {
    let formattedPhone = formatPhoneNumberIntl(detail.mobile).split(" ");
    let dataValue = {
      c_code: formattedPhone[0].replace("+", ""),
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    setIsLoading(true)
    setShowPopup(false);
    const boardingData = handleBoardingView(boardingSelection, busSelect);
    const droppingData = handleDroppingView(droppingSelection, busSelect);
    const tripFromLoc = boardingData[0]?.title == boardingData[0]?.descp ? boardingData[0]?.title : `${boardingData[0]?.title}, ${boardingData[0]?.descp}`
    const tripToLoc = droppingData[0]?.title == droppingData[0]?.descp ? droppingData[0]?.title : `${droppingData[0]?.title}, ${droppingData[0]?.descp}`
    // const tripFromLoc = busSelect?.start_location_descp
    // const tripToLoc = busSelect?.end_location_descp
    try {
      const tripData = {
        trip_date: convertToGMT(new Date(busSelect?.departure)),
        trip_from_loc: tripFromLoc,
        trip_to_loc: tripToLoc,
        trip_scheduled_pick_lat: boardingData[0]?.lat,
        trip_scheduled_pick_lng: boardingData[0]?.lng,
        trip_scheduled_drop_lat: droppingData[0]?.lat,
        trip_scheduled_drop_lng: droppingData[0]?.lng,
        trip_hrs: getTimeDistanceDifference(
          new Date(busSelect?.departure),
          new Date(busSelect?.arrival)
        ),
        trip_total_time: getTimeDistanceDifference(
          new Date(busSelect?.departure),
          new Date(busSelect?.arrival)
        ),
        // trip_pay_amount: totalFare,
        seats: seatDetail?.length,
        trip_status: tripDetail?.trip_status,
        // tax_amt: bookingSummary?.tax,
        // est_data: JSON.stringify(estimPriceList[busSelect?.category_id]),
        // ...(payMethod && payMethod !== ""
        //   ? { trip_pay_mode: payMethod }
        //   : {}),
        // trip_base_fare: estimPriceList[busSelect?.category_id]?.trip_base_fare,
        // trip_driver_commision:
        //   estimPriceList[busSelect?.category_id]?.trip_driver_commision,
        // trip_comp_commision:
        //   estimPriceList[busSelect?.category_id]?.trip_comp_commision,
        trip_customer_details: JSON.stringify({
          customer: formData?.map((value) => {
            delete value.errors; // Removes the errors field
            return value; // Returns the updated object
          }),
          detail: { ...detail, ...dataValue },         
          boarding: { ...boardingData[0], time: convertToGMT(new Date(busSelect?.departure)) },
          dropping: { ...droppingData[0], time: convertToGMT(new Date(busSelect?.arrival)) },
        }),
        trip_id: tripDetail?.trip_id,
        // trip_promo_amt: estimPriceList[busSelect?.category_id]?.trip_promo_amt,
        // trip_promo_code: estimPriceList[busSelect?.category_id]?.promo_code,
        // promo_id: estimPriceList[busSelect?.category_id]?.promo_id,
      };


      const tripResponse = await postUpdateTrip(tripData, apikey);

      if (tripResponse.status == 200) {

        toast.success("Your booking is updated");
        setIsLoading(false)
        sessionStorage.clear()
        localStorage.clear()
        setTimeout(() => {
          handleRedirectUrl(
            `${process.env.REACT_APP_ADMIN_TRIP_SUCCESS_API}`,
            "_self"
          );
        }, delayData.adminFormDelay);
      }

    } catch (error) {
      toast.dismiss();
      setShowPopup(false)
      console.log(`trip Update Save Error`, error);
      toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');

      setIsLoading(false)

      setTimeout(() => {
        // handleRedirectUrl(
        //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
        //   "_self"
        // );
        window?.location?.reload()
      }, delayData.adminFormDelay);
    }

  }

  {/* Cash Method */ }
  const handleCashMethod = async (payMethod) => {
    
    if(!mTripID){
      await getCategoryMTrip();
     }
    let formattedPhone = formatPhoneNumberIntl(detail.mobile).split(" ");
    let dataValue = {
      c_code: formattedPhone[0].replace("+", ""),
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    let smsNumber = `+${dataValue.c_code}${dataValue.u_phone}`
    setIsLoading(true)
    setShowPopup(false);
    const boardingData = handleBoardingView(boardingSelection, busSelect);
    const droppingData = handleDroppingView(droppingSelection, busSelect);
    const tripFromLoc = boardingData[0]?.title == boardingData[0]?.descp ? boardingData[0]?.title : `${boardingData[0]?.title}, ${boardingData[0]?.descp}`
    const tripToLoc = droppingData[0]?.title == droppingData[0]?.descp ? droppingData[0]?.title : `${droppingData[0]?.title}, ${droppingData[0]?.descp}`
    // const tripFromLoc = busSelect?.start_location_descp
    // const tripToLoc = busSelect?.end_location_descp
    if(!mTripID){
      window?.location?.reload()
      return
    }
    try {
      const cashFareValues = calcFareValues(
        Number(bookingSummary?.trip_base_fare) || 0,
        parseInt(companyId) > 1 ? FARE_PLATFORM_FEE_PERCENT : 0,
        parseInt(companyId) > 1 ? cityTax : 0
      );
      const tripData = {
        trip_date: convertToGMT(new Date(busSelect?.departure)),
        cat_name: busSelect?.cat_name,
        trip_from_loc: tripFromLoc,
        trip_to_loc: tripToLoc,
        city_id: CITY_ID,
        user_id: userid,
        category_id: busSelect?.category_id,
        driver_id: busSelect?.driver?.driver_id || 0,
        comp_id: companyId,
        trip_currency: "INR",
        trip_scheduled_pick_lat: boardingData[0]?.lat,
        trip_scheduled_pick_lng: boardingData[0]?.lng,
        trip_scheduled_drop_lat: droppingData[0]?.lat,
        trip_scheduled_drop_lng: droppingData[0]?.lng,
        trip_hrs: getTimeDistanceDifference(
          new Date(busSelect?.departure),
          new Date(busSelect?.arrival)
        ),
        // trip_distance: "10",
        trip_dunit: "km",
        trip_type: "cab",
        is_ride_later: 1,
        trip_total_time: getTimeDistanceDifference(
          new Date(busSelect?.departure),
          new Date(busSelect?.arrival)
        ),
        trip_pay_amount: Number(cashFareValues.totalFare) || totalFare,
        seats: seatDetail?.length,
        trip_status: "confirmed",
        is_share: "0",
        is_delivery: "0",
        tax_amt: Number(cashFareValues.gst) || 0,
        // est_data: JSON.stringify(estimPriceList[busSelect?.category_id]),
        // ...(payMethod && payMethod !== ""
        //   ? { trip_pay_mode: payMethod }
        //   : {}),
        trip_base_fare: bookingSummary?.trip_base_fare ?? totalFare,
        // trip_driver_commision:
        //   estimPriceList[busSelect?.category_id]?.trip_driver_commision,
        // trip_comp_commision:
        //   estimPriceList[busSelect?.category_id]?.trip_comp_commision,
         ...(payMethod && payMethod !== ""
           ? { trip_pay_mode: payMethod }
           : {}),
        trip_driver_commision: bookingSummary?.trip_base_fare ?? totalFare,
        trip_comp_commision: bookingSummary?.trip_comp_commision ?? 0,
        platform_fee: Number(cashFareValues.platformFee) || 0,
        trip_customer_details: JSON.stringify({
          customer: formData?.map((value) => {
            delete value.errors; // Removes the errors field
            return value; // Returns the updated object
          }),
          detail: { ...detail, ...dataValue },
                    boarding: { ...boardingData[0], time: convertToGMT(new Date(busSelect?.departure)) },
                    dropping: { ...droppingData[0], time: convertToGMT(new Date(busSelect?.arrival)) },
        }),
        seats_json: JSON.stringify(seatDetail?.map((value) => value.seat_id)),
        m_trip_id: mTripID,
        store_id: 1,
        is_return_details: true,
        // trip_promo_amt: estimPriceList[busSelect?.category_id]?.trip_promo_amt,
        // trip_promo_code: estimPriceList[busSelect?.category_id]?.promo_code,
        // promo_id: estimPriceList[busSelect?.category_id]?.promo_id,
      };

      const tripResponse = await postSaveTrip(tripData, apikey);

      if (tripResponse.status == 200) {

        toast.success("Your booking is successful");
        setIsLoading(false)
        sessionStorage.clear()
        localStorage.clear()
        
        if (busSelect?.driver) {
          handleSendSms(
                                `+${busSelect?.driver?.c_code}${busSelect?.driver?.d_phone}`,
                                `New Booking Alert for ${convertBookingDateFormat(
                                                          new Date(busSelect?.departure)
                                                        ).format('MMM DD')}th, ${convertBookingDateFormat(
                                                          new Date(busSelect?.departure)
                                                        ).format('YYYY')}. Customer: ${sessionStorage.getItem("name")} Contact: ${smsNumber || sessionStorage.getItem("phone")} Route: ${busSelect?.start_location} -> ${busSelect?.end_location} Ride confirmation is still pending Kindly contact the passenger to confirm the seat for the journey. Team - FAREX`
                              ,"driver");
                              handleSendSms(
                                smsNumber || sessionStorage.getItem("phone"),
                                `Dear ${sessionStorage.getItem("name")}, your ride from ${busSelect?.start_location} to ${busSelect?.end_location} is booked for ${convertBookingDateFormat(
                                                          new Date(busSelect?.departure)
                                                        ).format('DD MMM YYYY')} at ${convertBookingDateFormat(
                                                          new Date(busSelect?.departure)
                                                        ).format('hh:mm A')}. Driver:  ${busSelect?.driver?.d_name} | Contact: +${busSelect?.driver?.c_code}${busSelect?.driver?.d_phone}. Kindly contact the driver to confirm your ride. Have a safe journey! Team - Farex`
                              ,"customer");
        }
        setTimeout(() => {
          handleRedirectUrl(
            `${process.env.REACT_APP_ADMIN_TRIP_SUCCESS_API}`,
            "_self"
          );
        }, delayData.adminFormDelay);
      } else {
        if (
          tripResponse.data.resDecrypt.resDecrypt.message ===
          "Trip Duration Missing"
        )
          toast.error("Trip is not valid");
      }
    } catch (error) {
      toast.dismiss();
      setShowPopup(false)
      console.log(`trip Save Error`, error);
      toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');

      setIsLoading(false)

      setTimeout(() => {
        // handleRedirectUrl(
        //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
        //   "_self"
        // );
        window?.location?.reload()
      }, delayData.adminFormDelay);
    }
  }

  {/* Wallet Method */ }
  const handleWalletMethod = async (payMethod) => {
    let formattedPhone = formatPhoneNumberIntl(detail.mobile).split(" ");
    let dataValue = {
      c_code: formattedPhone[0].replace("+", ""),
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    let smsNumber = `+${dataValue.c_code}${dataValue.u_phone}`
    const fareValues = calcFareValues(
      Number(bookingSummary?.trip_base_fare) || 0,
      parseInt(companyId) > 1 ? FARE_PLATFORM_FEE_PERCENT : 0,
      parseInt(companyId) > 1 ? cityTax : 0
    );
    // const walletBalance = Number(sessionStorage.getItem('wmt'));
    // const tripAmount = Number(totalFare)
    // console.log({ walletBalance, tripAmount })
    // ////console.log({walletBalance})
    // if (walletBalance < tripAmount) {
    //   setWalletPopup(true);
    //   return
    // }

    setIsLoading(true)
    setShowPopup(false);
    const boardingData = handleBoardingView(boardingSelection, busSelect);
    const droppingData = handleDroppingView(droppingSelection, busSelect);
    const tripFromLoc = boardingData[0]?.title == boardingData[0]?.descp ? boardingData[0]?.title : `${boardingData[0]?.title}, ${boardingData[0]?.descp}`
    const tripToLoc = droppingData[0]?.title == droppingData[0]?.descp ? droppingData[0]?.title : `${droppingData[0]?.title}, ${droppingData[0]?.descp}`
    // const tripFromLoc = busSelect?.start_location_descp
    // const tripToLoc = busSelect?.end_location_descp
    try {
      const tripData = {
        trip_date: convertToGMT(new Date(busSelect?.departure)),
        cat_name: busSelect?.cat_name,
        trip_from_loc: tripFromLoc,
        trip_to_loc: tripToLoc,
        city_id: CITY_ID,
        user_id: userid,
        category_id: busSelect?.category_id,
        driver_id: busSelect?.driver?.driver_id || 0,
        comp_id: companyId,
        trip_currency: "INR",
        trip_scheduled_pick_lat: boardingData[0]?.lat,
        trip_scheduled_pick_lng: boardingData[0]?.lng,
        trip_scheduled_drop_lat: droppingData[0]?.lat,
        trip_scheduled_drop_lng: droppingData[0]?.lng,
        // trip_distance: "10",
        trip_dunit: "km",
        trip_type: "cab",
        is_ride_later: 1,
        trip_total_time: getTimeDistanceDifference(
          new Date(busSelect?.departure),
          new Date(busSelect?.arrival)
        ),
        trip_hrs: getTimeDistanceDifference(
          new Date(busSelect?.departure),
          new Date(busSelect?.arrival)
        ),
        trip_pay_amount: Number(fareValues.totalFare) || totalFare,
        seats: seatDetail?.length,
        trip_status: "confirmed",
        is_share: "0",
        is_delivery: "0",
        tax_amt: Number(fareValues.gst) || 0,
        platform_fee: Number(fareValues.platformFee) || 0,
        est_data: JSON.stringify(estimPriceList[busSelect?.category_id] || {}),
        trip_pay_mode: 'Wallet',
        trip_base_fare: bookingSummary?.trip_base_fare ?? estimPriceList[busSelect?.category_id]?.trip_base_fare,
        trip_driver_commision:
          bookingSummary?.trip_base_fare ?? estimPriceList[busSelect?.category_id]?.trip_driver_commision,
        trip_comp_commision:
          bookingSummary?.trip_comp_commision ?? estimPriceList[busSelect?.category_id]?.trip_comp_commision,
        trip_customer_details: JSON.stringify({
          customer: formData?.map((value) => {
            delete value.errors; // Removes the errors field
            return value; // Returns the updated object
          }),
          detail: { ...detail, ...dataValue },
                    boarding: {...boardingData[0], time: convertToGMT(new Date(busSelect?.departure)) },
                    dropping: {...droppingData[0], time: convertToGMT(new Date(busSelect?.arrival)) },
        }),
        seats_json: JSON.stringify(seatDetail?.map((value) => value.seat_id)),
        m_trip_id: mTripID,
        is_prepaid: 1,
        trip_pay_status: 'Paid',
        trip_pay_date: getFormattedDateTime(),
        is_return_details: true,
        transaction: JSON.stringify({
          user_id: userid,
          trip_id: 0,          ////driver_id: busSelect?.driver?.driver_id,
          pay_mode: "Wallet",
          d_curr: "INR",
          is_change_paid: 1,
          r_curr: "INR",
          // pay_amount: totalFare,
          // total_amt: totalFare,
          // rider_amt: totalFare,
          // promo_amt: estimPriceList[busSelect?.category_id]?.trip_promo_amt,
          // commission_amt:
          //   estimPriceList[busSelect?.category_id]?.trip_comp_commision,
          // trip_driver_commision:
          //   estimPriceList[busSelect?.category_id]?.trip_driver_commision,
          pay_amount: Number(fareValues.advanceAmount),
          total_amt: Number(fareValues.advanceAmount),
          rider_amt: Number(fareValues.advanceAmount),
          promo_amt: Number(estimPriceList[busSelect?.category_id]?.trip_promo_amt) || 0,
          commission_amt: Number(estimPriceList[busSelect?.category_id]?.trip_comp_commision) || 0,
          trip_driver_commision: Number(estimPriceList[busSelect?.category_id]?.trip_driver_commision) || 0,
          trip_comp_commision: Number(estimPriceList[busSelect?.category_id]?.trip_comp_commision) || 0,
          trans_desc: "Trip Payment",
          curr_multiplier: 1,
          "pay_response": "Transaction Successful",
          api_key: apikey,
        }),
        store_id: 1,
        // trip_promo_amt: estimPriceList[busSelect?.category_id]?.trip_promo_amt,
        // trip_promo_code: estimPriceList[busSelect?.category_id]?.promo_code,
        // promo_id: estimPriceList[busSelect?.category_id]?.promo_id,
      };

      const tripResponse = await postSaveTripWithTrans(tripData, apikey);

      if (tripResponse.status == 200) {
        toast.success("Your booking is successful");
        setIsLoading(false)
        
        if (busSelect?.driver) {
          handleSendSms(
                                `+${busSelect?.driver?.c_code}${busSelect?.driver?.d_phone}`,
                                `New Booking Alert for ${convertBookingDateFormat(
                                                          new Date(busSelect?.departure)
                                                        ).format('MMM DD')}th, ${convertBookingDateFormat(
                                                          new Date(busSelect?.departure)
                                                        ).format('YYYY')}. Customer: ${sessionStorage.getItem("name")} Contact: ${smsNumber || sessionStorage.getItem("phone")} Route: ${busSelect?.start_location} -> ${busSelect?.end_location} Ride confirmation is still pending Kindly contact the passenger to confirm the seat for the journey. Team - FAREX`
                              ,"driver");
                              handleSendSms(
                                smsNumber || sessionStorage.getItem("phone"),
                                `Dear ${sessionStorage.getItem("name")}, your ride from ${busSelect?.start_location} to ${busSelect?.end_location} is booked for ${convertBookingDateFormat(
                                                          new Date(busSelect?.departure)
                                                        ).format('DD MMM YYYY')} at ${convertBookingDateFormat(
                                                          new Date(busSelect?.departure)
                                                        ).format('hh:mm A')}. Driver:  ${busSelect?.driver?.d_name} | Contact: +${busSelect?.driver?.c_code}${busSelect?.driver?.d_phone}. Kindly contact the driver to confirm your ride. Have a safe journey! Team - Farex`
                              ,"customer");
        }
        setTimeout(() => {
          handleRedirectUrl(
            `${process.env.REACT_APP_ADMIN_TRIP_SUCCESS_API}`,
            "_self"
          );
        }, delayData.adminFormDelay);
        sessionStorage.clear()
        localStorage.clear()
      } else {
        if (
          tripResponse.data.resDecrypt.resDecrypt.message ===
          "Trip Duration Missing"
        )
          toast.error("Trip is not valid");
      }
    } catch (error) {
      toast.dismiss();
      setShowPopup(false)
      console.log(`trip Save Error`, error);
      toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');

      setIsLoading(false)

      setTimeout(() => {
        // handleRedirectUrl(
        //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
        //   "_self"
        // );
        window?.location?.reload()
      }, delayData.adminFormDelay);
    }
  }

  const fetchEstimateFareData = async () => {
    const searchData = sessionStorage.getItem("bookingdetails");
    const searchValue = JSON.parse(searchData);
    try {
      let data = {
        trip_from_loc: searchValue?.boarding,
        trip_to_loc: searchValue?.dropping,
        trip_date: convertToGMT(new Date(busSelect?.departure)),
        api_key: apikey,
        city_id: CITY_ID,
        // user_id: userid,
        seats: seatDetail?.length,
        trip_hrs: getTimeDistanceDifference(
          new Date(busSelect?.departure),
          new Date(busSelect?.arrival)
        ),
        is_share: 0,
        polyline: "0",
        ...(promoCode && promoCode !== "" ? { promo_code: promoCode } : {}),
        amount: amountVal,
        company_id: companyId
      };
      const result = await getEstimateFareByData(data, apikey);
      if (result?.status === 200) {
        setEstimPriceList(result.data.resDecrypt.response);
      }
    } catch (error) {
      console.log("Fetch Api Error::", error);
    }
  };

  const handleCityFilter = (cityData) => {
    const value = cityData?.map((value) => {
      return value?.city_pay_options?.split('|')
    }).flat()  // Flatten the array
      .map(option => option.charAt(0).toUpperCase() + option.slice(1));
    return value?.filter((valueItem) => !['card', 'Card', 'stripe', 'Stripe','Cash','cash'].includes(valueItem))
  }

  const handlePaymentMethodChange = async(e) => {
    const value = String(e.target.value)
    await getUserData()
    getCategoryMTrip()

    if (value.toUpperCase() == "WALLET") {
      const walletBalance = Number(sessionStorage.getItem('wmt'));     ////console.log({walletBalance})

      if (walletBalance <= 0) {
        setWalletPopup(true);
        return;
      }

      const fareValues = calcFareValues(
        Number(bookingSummary?.trip_base_fare) || 0,
        parseInt(companyId) > 1 ? FARE_PLATFORM_FEE_PERCENT : 0,
        parseInt(companyId) > 1 ? cityTax : 0
      );
      const tripAmount = Number(fareValues.advanceAmount)
      // console.log({ walletBalance, tripAmount })
      ////console.log({walletBalance})
      if (walletBalance < tripAmount) {
        setWalletPopup(true);
        return
      }
    }
    setPaymentMethod(value)
    setErr({ ...err, payment: '' })
  }


  // const handlePaymentStatusChange = (e) => {
  //   const value = String(e.target.value)
  //   getUserData()
  //   getCategoryMTrip()
  //   setPaymentStatus(value)
  //   setErr({ ...err, payment_status: '' })
  // }

  const handleWalletCancelPopup = () => {
    setWalletPopup(false);
    setShowPopup(false)
  };


  const handleWalletRedirect = () => {
    setWalletPopup(false);
    setShowPopup(false);
    setPaymentMethod("Wallet")
  };

  const handleCompleteButton = async () => {

    let formattedPhone = formatPhoneNumberIntl(detail.mobile).split(" ");
    let dataValue = {
      c_code: formattedPhone[0].replace("+", ""),
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    setIsLoading(true)
    setShowPopup(false);
    
    const tripFromLoc = busSelect?.start_location_descp
    const tripToLoc = busSelect?.end_location_descp
    try {

      const tripData = {}

      const tripResponse = await postUpdateTrip(tripData, apikey);

      if (tripResponse.status == 200) {

        toast.success("Your booking is updated");
        setIsLoading(false)
        sessionStorage.removeItem('bookingdetails');
        setTimeout(() => {
          handleRedirectUrl(
            `${process.env.REACT_APP_ADMIN_TRIP_SUCCESS_API}`,
            "_self"
          );
        }, delayData.adminFormDelay);
      }

    } catch (error) {
      toast.dismiss();
      setShowPopup(false)
      console.log(`trip Update Save Error`, error);
      toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');

      setIsLoading(false)

      setTimeout(() => {
        // handleRedirectUrl(
        //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
        //   "_self"
        // );
        window?.location?.reload()
      }, delayData.adminFormDelay);
    }

  }

  const handleExpiredButton = async () => {

    let formattedPhone = formatPhoneNumberIntl(detail.mobile).split(" ");
    let dataValue = {
      c_code: formattedPhone[0].replace("+", ""),
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    setIsLoading(true)
    setShowPopup(false);
    
    const tripFromLoc = busSelect?.start_location_descp
    const tripToLoc = busSelect?.end_location_descp
    try {

      const tripData = {}

      const tripResponse = await postUpdateTrip(tripData, apikey);

      if (tripResponse.status == 200) {

        toast.success("Your booking is updated");
        setIsLoading(false)
        sessionStorage.removeItem('bookingdetails');
        setTimeout(() => {
          handleRedirectUrl(
            `${process.env.REACT_APP_ADMIN_TRIP_SUCCESS_API}`,
            "_self"
          );
        }, delayData.adminFormDelay);
      }

    } catch (error) {
      toast.dismiss();
      setShowPopup(false)
      console.log(`trip Update Save Error`, error);
      toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');

      setIsLoading(false)

      setTimeout(() => {
        // handleRedirectUrl(
        //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
        //   "_self"
        // );
        window?.location?.reload()
      }, delayData.adminFormDelay);
    }
  }

  const handleCancelledButton = async () => {

    let formattedPhone = formatPhoneNumberIntl(detail.mobile).split(" ");
    let dataValue = {
      c_code: formattedPhone[0].replace("+", ""),
      u_phone: formattedPhone.slice(1).join("").replace(/\s+/g, ""), // Remove spaces and join
    };
    setIsLoading(true)
    setShowPopup(false);
    
    const tripFromLoc = busSelect?.start_location_descp
    const tripToLoc = busSelect?.end_location_descp

    try {


      const tripData = {}

      const tripResponse = await postUpdateTrip(tripData, apikey);

      if (tripResponse.status == 200) {

        toast.success("Your booking is updated");
        setIsLoading(false)
        sessionStorage.removeItem('bookingdetails');
        setTimeout(() => {
          handleRedirectUrl(
            `${process.env.REACT_APP_ADMIN_TRIP_SUCCESS_API}`,
            "_self"
          );
        }, delayData.adminFormDelay);
      }

    } catch (error) {
      toast.dismiss();
      setShowPopup(false)
      console.log(`trip Update Save Error`, error);
      toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');

      setIsLoading(false)

      setTimeout(() => {
        // handleRedirectUrl(
        //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
        //   "_self"
        // );
        window?.location?.reload()
      }, delayData.adminFormDelay);
    }
  }

  
  const handleSendSms = async (number, message,type) => {
    try {
      const response = await sendBookingSMS({
        msg: message,
        ph: number,
        type
      });

      if (response.status === 200) {
        console.log("Booking SMS sent successfully:", response.data);
      }
    } catch (error) {
      console.error("Booking Sms Send Error:", error);
    }
  };

  return (
    <>
      {isLoading && <Loader classValue="loader_container_main" />}
      <div className="overlay_passenger" />
      {view === 0 && (
        <form onSubmit={handleSubmit}>
          <section className="admin_passenger_detail_container passenger_detail_container">
            <div className="passenger_detail_container_header">
              <div
                className="passenger_detail_container_header_left"
                onClick={handleFormClose}
                style={adminEditStatus.includes(tripDetail?.trip_status) ? { pointerEvents: 'none' } : {}}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
              </div>
              <div className="passenger_detail_container_header_right">
                Passenger Details
              </div>
            </div>
            <div className="passenger_detail_container_detail">
              <div className="passenger_detail_container_detail_passenger">
                <div className="passenger_detail_container_detail_passenger_title">
                  <div className="passenger_detail_container_detail_passenger_title_left">
                    <img src={userIcon} alt="User" />
                  </div>
                  <div className="passenger_detail_container_detail_passenger_title_right">
                    Passenger Information
                  </div>
                </div>
                {seatDetail?.map((seatData, index) => (
                  <div
                    key={seatData.id}
                    className="passenger_detail_container_detail_passenger_form"
                  >
                    <div className="passenger_detail_container_detail_passenger_form_title">
                      Passenger {index + 1} 
                      {/* | <span>Seat {seatData?.id}</span> */}
                    </div>
                    <div className="passenger_detail_container_detail_passenger_form_content">
                      <div className="form_name">
                        <label htmlFor={`name-${seatData?.id}`}>Name</label>
                        <input
                          type="text"
                          id={`name-${seatData.id}`}
                          value={formData[index]?.name}
                          onChange={(e) => handleInputChange(e, index, "name")}
                          placeholder="Name"
                          className="contact-ph-input"
                          disabled={adminEditStatus.includes(tripDetail?.trip_status)}
                        />
                        {formData[index]?.errors?.name && (
                          <span className="error">
                            {formData[index]?.errors?.name}
                          </span>
                        )}
                      </div>

                      <div className="form_content">
                        <div className="form_gender">
                          <label htmlFor={`gender-${seatData?.id}`}>
                            Gender
                          </label>
                          <div className="form_gender_value">
                            <div className="form_gender_value_male">
                              <input
                                type="radio"
                                name={`gender-${seatData?.id}`}
                                id={`male-${seatData?.id}`}
                                value="Male"
                                checked={formData[index]?.gender === "Male"}
                                onChange={(e) =>
                                  handleInputChange(e, index, "gender")
                                }
                                disabled={adminEditStatus.includes(tripDetail?.trip_status)}
                              />
                              <span style={adminEditStatus.includes(tripDetail?.trip_status) ? { pointerEvents: 'none' } : {}} onClick={() => { handleInputChange({ target: { value: 'Male' } }, index, "gender") }}>Male</span>
                            </div>
                            <div className="form_gender_value_female">
                              <input
                                type="radio"
                                name={`gender-${seatData?.id}`}
                                id={`female-${seatData?.id}`}
                                value="Female"
                                checked={formData[index]?.gender === "Female"}
                                onChange={(e) =>
                                  handleInputChange(e, index, "gender")
                                }
                                disabled={adminEditStatus.includes(tripDetail?.trip_status)}
                              />
                              <span style={adminEditStatus.includes(tripDetail?.trip_status) ? { pointerEvents: 'none' } : {}} onClick={() => { handleInputChange({ target: { value: 'Female' } }, index, "gender") }}>Female</span>
                            </div>
                          </div>
                          {formData[index]?.errors?.gender && (
                            <span className="error">
                              {formData[index]?.errors?.gender}
                            </span>
                          )}
                        </div>

                        <div className="form_age">
                          <label htmlFor={`age-${seatData?.id}`}>Age</label>
                          <select
                            id={`age-${seatData?.id}`}
                            value={formData[index]?.age}
                            onChange={(e) => handleInputChange(e, index, "age")}
                            className="contact-ph-input age_dropdown"
                            disabled={adminEditStatus.includes(tripDetail?.trip_status)}
                          >
                            <option value="">Select Age</option>
                            {Array(100)
                              .fill().map((value, index) => (
                                <option key={index + 1} value={index + 1}>{index + 1}</option>
                              ))}
                          </select>
                          {formData[index]?.errors?.age && (
                            <span className="error">
                              {formData[index]?.errors?.age}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="passenger_detail_container_detail_contact">
                <div className="passenger_detail_container_detail_contact_title">
                  <div className="passenger_detail_container_detail_contact_title_left">
                    <img src={contactIcon} alt="Contact" />
                  </div>
                  <div className="passenger_detail_container_detail_contact_title_right">
                    Contact Details
                  </div>
                </div>
                <div className="passenger_detail_container_detail_contact_form">
                  <div className="form_email">
                    <label htmlFor="email">Email</label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      value={detail?.email}
                      onChange={handleDetailChange}
                      placeholder="Email"
                      className="contact-ph-input"
                      disabled={adminEditStatus.includes(tripDetail?.trip_status)}
                    />
                    {err?.email && <span className="error">{err?.email}</span>}
                  </div>
                  <div className="form_mobile">
                    <label htmlFor="mobile">Mobile</label>
                    <div className="form_mobile_content">
                      <PhoneInput
                        name="mobile"
                        international={true}
                        defaultCountry="IN"
                        value={detail?.mobile}
                        disabled={adminEditStatus.includes(tripDetail?.trip_status)}
                        onChange={(value) => {
                          // Update formik value for phone number
                          handleMobileChange({
                            target: { name: "mobile", value },
                          });
                        }}
                        className={
                          err.mobile
                            ? "input-error contact-ph-input"
                            : "contact-ph-input"
                        }
                      />
                    </div>
                    {err?.mobile && (
                      <span className="error">{err?.mobile}</span>
                    )}
                    {err?.country && (
                      <span className="error">{err?.country}</span>
                    )}
                  </div>
                  {/* {!params?.id && <div className="form_promo">
                    <label htmlFor="promo">Promo Code</label>
                    <div className="form_promo_content">
                      <input
                        type="text"
                        id="promo"
                        value={promoCode}
                        onChange={handlePromoChange}
                        placeholder="Promo Code"
                        className="contact-ph-input"
                      
                      />
                      {applypromocode ? <button className="common_button_border" type="button" onClick={handleResetPromo}>
                        Reset
                      </button> : <button className="common_button_border" type="button" onClick={handleApplyCoupon}>
                        Apply
                      </button>}
                    </div>
                    {err?.promoCode && (
                      <span className="error">{err?.promoCode}</span>
                    )}
                  </div>} */}
                </div>
              </div>
              
              {!params?.id && 
                            <div className="passenger_detail_container_detail_instruction">
                              <div className="passenger_detail_container_detail_instruction_title">
                                Instructions
                              </div>
                              <ul className="passenger_detail_container_detail_instruction_content">
                                {bookingInstructionData?.map((value) => (
                                  <li key={value?.id}>{value?.description}</li>
                                ))}
                              </ul>
                            </div>}

              <div className="passenger_detail_container_footer">
                <div className="passenger_detail_container_footer_terms">
                  <div className="passenger_detail_container_footer_terms_main">
                    <label className="no_margin" htmlFor="terms">
                      <input
                        name="terms"
                        id="terms"
                        checked={check}
                        type="checkbox"
                        onChange={(e) => { handleCheckTerms(e.target.checked) }}
                        className="no_margin"
                        disabled={adminEditStatus.includes(tripDetail?.trip_status)}
                      />
                    </label>
                    <p style={adminEditStatus.includes(tripDetail?.trip_status) ? { pointerEvents: 'none', lineHeight: "1.2" } : { lineHeight: "1.2" }} className="no_margin" onClick={() => { handleCheckTerms(!check) }}>
                      I understand and agree with the
                      Terms of Service and Cancellation
                      .
                    </p>
                  </div>
                  {err?.terms && <span className="error">{err?.terms}</span>}
                </div>
                <div className="passenger_detail_container_footer_button">
                  <div className="passenger_detail_container_footer_amount_item">
                    {(() => {
                      const isPremium = parseInt(companyId) > 1;
                      const fareValues = calcFareValues(
                        Number(bookingSummary?.trip_base_fare) || 0,
                        isPremium ? FARE_PLATFORM_FEE_PERCENT : 0,
                        isPremium ? cityTax : 0
                      );
                      return (
                        <>
                          <div className="passenger_detail_container_footer_amount">
                            <div className="passenger_detail_container_footer_amount_title">
                              Base Fare:
                            </div>
                            <div className="passenger_detail_container_footer_amount_amount">
                              &#8377; {fareValues.tripAmountOnly}
                            </div>
                          </div>
                          {isPremium && (
                            <div className="passenger_detail_container_footer_amount">
                              <div className="passenger_detail_container_footer_amount_title">
                                GST (5%):
                              </div>
                              <div className="passenger_detail_container_footer_amount_amount">
                                &#8377; {fareValues.gst}
                              </div>
                            </div>
                          )}
                          <div className="passenger_detail_container_footer_amount_divider">----------------</div>
                          <div className="passenger_detail_container_footer_amount">
                            <div className="passenger_detail_container_footer_amount_title">
                              Total Fare:
                            </div>
                            <div className="passenger_detail_container_footer_amount_amount">
                              &#8377; {fareValues.totalFare}
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                  <button className="common_button_border" type="submit">Proceed to Book</button>
                </div>
              </div>
            </div>
          </section>
        </form>
      )}
      {view === 1 && (
        <section className="admin_passenger_detail_container_view passenger_detail_container_view">
          <div className="passenger_detail_container_view_header">
            <div
              className="passenger_detail_container_view_header_left"
              onClick={() => {
                handleViewChange(0);
              }}
              style={adminEditStatus.includes(tripDetail?.trip_status) ? { pointerEvents: 'none' } : {}}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                width="24"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </div>
            <div className="passenger_detail_container_view_header_right">
              Booking Details
            </div>
          </div>
          <div className="passenger_detail_container_view_detail">
            <div className="passenger_detail_container_view_detail_form">
              <div className="passenger_detail_container_view_detail_form_busName">
                {busSelect?.cat_name}
              </div>
              <div className="passenger_detail_container_view_detail_form_line" />
               {busSelect?.driver && (
                              <>
                                <div className="passenger_detail_container_view_detail_form_driver">
                                  <div className="passenger_detail_container_view_detail_form_driver_header">
                                    <div className="passenger_detail_container_view_detail_form_driver_header_icon">
                                      <img src={driverIcon} alt="User" />
                                    </div>
                                    <div className="passenger_detail_container_view_detail_form_driver_detail">
                                      <div className="passenger_detail_container_view_detail_form_driver_detail_main">
                                      <div className="passenger_detail_container_view_detail_form_driver_title">
                                        Driver Detail
                                      </div>
                                        {busSelect?.driver && (
                                        <>
                                          <div
                                            className={`passenger_detail_main_cab_item_container_second ${
                                              busSelect?.driver?.car
                                                ? ""
                                                : "passenger_detail_main_cab_item_container_fourth_padding"
                                            }`}
                                          >
                                            <aside className="passenger_detail_main_cab_item_container_second_left">
                                              <div
                                                className={`passenger_detail_main_cab_item_container_second_left_image ${
                                                  busSelect?.driver?.d_is_verified
                                                    ? "passenger_detail_main_cab_item_container_second_left_image_verify"
                                                    : ""
                                                }`}
                                              >
                                                {busSelect?.driver?.d_profile_image_path ? (
                                                  <img
                                                    className="passenger_detail_main_cab_item_container_second_left_image_tag"
                                                    src={`${process.env.REACT_APP_BACKEND_IMAGE_URL}${busSelect?.driver?.d_profile_image_path}`}
                                                    alt=""
                                                    onError={(e) => {
                                                      e.target.onerror = null; // prevent infinite loop if default image also fails
                                                      e.target.src = DriverIcon; // set fallback image
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    className="passenger_detail_main_cab_item_container_second_left_image_tag"
                                                    src={DriverIcon}
                                                    alt={busSelect?.driver?.d_name}
                                                  />
                                                )}
                                                {busSelect?.driver?.d_is_verified && (
                                                  <span className="passenger_detail_main_cab_item_container_second_left_image_verify_icon">
                                                    <img src={VerifiedIcon} alt="Verified" />
                                                  </span>
                                                )}
                                              </div>
                                              <div className="passenger_detail_main_cab_item_container_second_left_heading">
                                                <div className="passenger_detail_main_cab_item_container_second_left_heading_title">
                                                  {busSelect?.driver?.d_name}
                                                </div>
                                                <div className="passenger_detail_main_cab_item_container_second_left_heading_rating">
                                                  <i className="fas fa-star"></i>{" "}
                                                  <span>{busSelect?.driver?.d_rating}</span>
                                                  <span>
                                                    - {busSelect?.driver?.d_rating_count}{" "}
                                                    ratings
                                                  </span>
                                                </div>
                                              </div>
                                            </aside>
                                            <aside className="passenger_detail_main_cab_item_container_second_right"></aside>
                                          </div>
                                        </>
                                      )}
                                      </div>
                                      {busSelect?.driver?.car && (
                                        <div className="passenger_detail_container_view_detail_form_car_main">
                                        
                                      <div className="passenger_detail_container_view_detail_form_driver_title">
                                        Vehicle Detail
                                      </div>
                                          <div
                                            className={`passenger_detail_main_cab_item_container_third`}
                                          >
                                            <aside className="passenger_detail_main_cab_item_container_third_left">
                                              <div className="passenger_detail_main_cab_item_container_third_right_icon">
                                                {busSelect?.driver?.car?.car_image_path ? (
                                                  <img
                                                    className="passenger_detail_main_cab_item_container_second_left_image_tag"
                                                    src={`${process.env.REACT_APP_BACKEND_IMAGE_URL}${busSelect?.driver?.car?.car_image_path}`}
                                                    alt=""
                                                    onError={(e) => {
                                                      e.target.onerror = null; // prevent infinite loop if default image also fails
                                                      e.target.src = CarIcon; // set fallback image
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    className="passenger_detail_main_cab_item_container_second_left_image_tag"
                                                    src={CarIcon}
                                                    alt={busSelect?.driver?.car?.car_name}
                                                  />
                                                )}
                                              </div>
                                              <div className="passenger_detail_main_cab_item_container_third_right_name">
                                                {busSelect?.driver?.car?.car_name}(
                                                {busSelect?.driver?.car?.car_model}){" "}
                                                {busSelect?.driver?.car?.car_color &&<div className="passenger_detail_main_cab_item_container_third_right_name">
                                  {busSelect?.driver?.car?.car_color}
                                </div>}
                                              </div>
                                            </aside>
                                            <aside className="passenger_detail_main_cab_item_container_third_right"></aside>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="passenger_detail_container_view_detail_form_line" />
                              </>
                            )}
              <div className="passenger_detail_container_view_detail_form_timing">
                <div className="passenger_detail_container_view_detail_form_timing_left">
                  <div className="passenger_detail_container_view_detail_form_timing_left_icon">
                    <img src={calendarIcon} alt="Calendar" />
                  </div>
                  <div className="passenger_detail_container_view_detail_form_timing_left_main">
                    <div className="passenger_detail_container_view_detail_form_timing_left_title">
                      Departure
                    </div>

                                        <div
                                          className="passenger_detail_container_view_detail_form_timing_left_value"
                                        >
                                          <span className="date">
                                            {getBookingFormatedDateValue(new Date(busSelect?.departure))}
                                          </span>
                                          <span className="time">
                                            {getBookingFormatedValue(new Date(busSelect?.departure))}
                                          </span>
                                        </div>
                    {/* {handleBoardingView(boardingSelection, busSelect)?.map(
                      (point) => (
                        <div
                          key={point?.id}
                          className="passenger_detail_container_view_detail_form_timing_left_value"
                        >
                          <span className="date">
                            {getBookingFormatedDateValue(new Date(point?.time))}
                          </span>
                          <span className="time">
                            {getBookingFormatedValue(new Date(point?.time))}
                          </span>
                        </div>
                      )
                    )} */}
                  </div>
                </div>
                <div className="passenger_detail_container_view_detail_form_timing_right">
                  <div className="passenger_detail_container_view_detail_form_timing_right_title">
                    Seats
                  </div>
                  <div className="passenger_detail_container_view_detail_form_timing_right_value">
                    {/* {seatDetail?.map((seatData) => seatData.id).join(", ")} */}
                    {seatDetail?.map((seatData) => seatData.id).length}
                  </div>
                </div>
              </div>
              <div className="passenger_detail_container_view_detail_form_line" />
              <div className="passenger_detail_container_view_detail_form_location">
                <div className="passenger_detail_container_view_detail_form_location_left">
                  <div className="passenger_detail_container_view_detail_form_location_left_icon">
                    <img src={LocationIcon} alt="Location" />
                  </div>
                  <div className="passenger_detail_container_view_detail_form_location_left_main">
                    <div className="passenger_detail_container_view_detail_form_location_left_title">
                      Boarding Point
                    </div>
                    <div className="passenger_detail_container_view_detail_form_location_left_value">
                      <div className="passenger_detail_container_view_detail_form_location_left_value_title">
                        {searchDetail?.boarding}
                      </div>
                      {handleBoardingView(boardingSelection, busSelect)?.map(
                        (point) => (
                          <div
                            key={point?.id}
                            className="passenger_detail_container_view_detail_form_location_left_value_detail"
                          >
                            {point?.descp}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
                <div className="passenger_detail_container_view_detail_form_location_right">
                  <div className="passenger_detail_container_view_detail_form_location_right_title">
                    Dropping Point
                  </div>
                  <div className="passenger_detail_container_view_detail_form_location_right_value">
                    <div className="passenger_detail_container_view_detail_form_location_right_value_title">
                      {searchDetail?.dropping}
                    </div>
                    {handleDroppingView(droppingSelection, busSelect)?.map(
                      (point) => (
                        <div
                          key={point?.id}
                          className="passenger_detail_container_view_detail_form_location_right_value_detail"
                        >
                          {point?.descp}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
              <div className="passenger_detail_container_view_detail_form_line" />
              <div className="passenger_detail_container_view_detail_form_user">
                <div className="passenger_detail_container_view_detail_form_user_header">
                  <div className="passenger_detail_container_view_detail_form_user_header_icon">
                    <img src={userIcon} alt="User" />
                  </div>
                  <div className="passenger_detail_container_view_detail_form_user_detail">
                    <div className="passenger_detail_container_view_detail_form_user_title">
                      Passenger Detail
                    </div>
                    {formData?.map((seatData) => (
                      <div
                        key={seatData?.id}
                        className="passenger_detail_container_view_detail_form_user_detail_item"
                      >
                        <span className="title">{seatData?.name}</span>{" "}
                        {seatData?.age && seatData?.gender && (
                          <span className="value">
                            ({seatData?.age},{seatData?.gender})
                          </span>
                        )}
                      </div>
                    ))}

                    <div className="passenger_detail_container_view_detail_form_user_detail_value">
                      <div className="passenger_detail_container_view_detail_form_user_detail_email">
                        {detail?.email}
                      </div>
                      <div className="passenger_detail_container_view_detail_form_user_detail_mobile">
                        {handlePhoneView(detail?.mobile)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="passenger_detail_container_view_detail_form_line" />
              <div className="passenger_detail_container_view_detail_form_fare">
                <div className="passenger_detail_container_view_detail_form_fare_title">
                  Fare Details
                </div>
                <div className="passenger_detail_container_view_detail_form_fare_detail">
                  {(() => {
                    const isPremium = parseInt(companyId) > 1;
                    const fareValues = calcFareValues(
                      Number(bookingSummary?.trip_base_fare) || 0,
                      isPremium ? FARE_PLATFORM_FEE_PERCENT : 0,
                      isPremium ? cityTax : 0
                    );
                    return (
                      <>
                        <div className="passenger_detail_container_view_detail_form_fare_detail_item">
                          <div className="passenger_detail_container_view_detail_form_fare_detail_item_title">
                            Base Fare
                          </div>
                          <div className="passenger_detail_container_view_detail_form_fare_detail_item_value">
                            &#8377; {fareValues.tripAmountOnly}
                          </div>
                        </div>
                        {isPremium && (
                          <div className="passenger_detail_container_view_detail_form_fare_detail_item">
                            <div className="passenger_detail_container_view_detail_form_fare_detail_item_title">
                              GST (5%)
                            </div>
                            <div className="passenger_detail_container_view_detail_form_fare_detail_item_value">
                              &#8377; {fareValues.gst}
                            </div>
                          </div>
                        )}
                        <div className="passenger_detail_container_view_detail_form_fare_detail_item_divider">----------------</div>
                        <div className="passenger_detail_container_view_detail_form_fare_detail_item">
                          <div className="passenger_detail_container_view_detail_form_fare_detail_item_title">
                            Total Fare
                          </div>
                          <div className="passenger_detail_container_view_detail_form_fare_detail_item_value">
                            &#8377; {fareValues.totalFare}
                          </div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
              <div className="passenger_detail_container_view_detail_form_line" />
            </div>                       
            {/* <div className="passenger_detail_container_view_detail_form_note">
              <p>Note: After booking, please connect with the driver to confirm your ride.</p>
            </div> */}
            <div className="passenger_detail_container_view_detail_form_button">
              {/* <div className="form_paymentStatus">
                <label htmlFor="paymentStatus">Select Payment Status</label>
                <select
                  id="paymentStatus"
                  value={paymentStatus}
                  onChange={handlePaymentStatusChange}
                  className="contact-ph-input age_dropdown"
                >                
                  <option value="">Unpaid</option>                  
                  <option value="Paid">Paid</option>                  
                </select>
              </div> */}
              {!params?.id && parseInt(companyId) > 1 &&  <div className="form_paymentMethod">
                <label htmlFor="paymentMethod">Select Payment Method</label>
                <select
                  id="paymentMethod"
                  value={paymentMethod}
                  onChange={handlePaymentMethodChange}
                  className="contact-ph-input age_dropdown"
                >
                  <option value="">Select Payment Method</option>
                  {handleCityFilter(citydrop).map((value) => (
                    <option key={value} value={value}>{getPaymentDisplayLabel(value, localisations)}</option>
                  ))}
                </select>
                {err && (
                  <span className="error">
                    {err?.payment}
                  </span>
                )}
              </div>}
              {/* {params?.id && <div className="passenger_detail_container_view_detail_form_button_flex">
              <button className="common_button_border" type="button">
                Mark As Completed
              </button>
              <button className="common_button_border" type="button">
                Mark As Expired
              </button>
              <button className="common_button_border" type="button" >
                Mark As Cancelled
              </button>
              </div>} */}
              {!adminEditStatus.includes(tripDetail?.trip_status) && <button className="common_button_border" type="button" onClick={() => {
                if (params?.id) {
                  handlePayButtonEdit()
                  return
                }

                handlePayButton()
              }}>
                {params?.id ? "Update" : (parseInt(companyId) > 1 ? (() => {
                  const fareValues = calcFareValues(Number(bookingSummary?.trip_base_fare) || 0, FARE_PLATFORM_FEE_PERCENT, cityTax);
                  return `Pay ₹${fareValues.advanceAmount} Advance and Book`;
                })() : "Book")}
              </button>}
            </div> 
          </div>
        </section>
      )}
      {showPopup && (
        <section className="passenger_payment_main_container">
          <div className="backdrop" />
        </section>
      )}

      {walletPopup && (
        <WalletPopup
          handleCancel={handleWalletCancelPopup}
          handleRedirect={handleWalletRedirect}
          btntitle="Continue"
          title="Insufficient wallet balance! Booking with the wallet may lead to a negative balance."
        />
      )}
    </>
  );
};

export default AdminPassengerDetail;

const validateFormData = (email, mobileNumber, terms) => {
  const result = {};

  // Email Validation Checks
  // if (!email) {
  //   result.email = "Email is required.";
  // } 

  if (email) {
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      result.email = "Please enter a valid email address.";
    }
  }
  // Mobile Number Validation Checks
  if (!mobileNumber) {
    result.mobile = "Mobile number is required.";
  } else if (!/^[0-9]{8,12}$/.test(mobileNumber)) {
    result.mobile = "Mobile number must be between 8 to 12 digits.";
  } else if (!(mobileNumber?.length >= 8 && mobileNumber?.length <= 12)) {
    result.mobile = "Mobile number must be between 8 to 12 digits.";
  }

  // Terms Validation
  if (!terms) {
    result.terms = "Please accept terms and condition";
  }

  // Return the result with any err
  return result;
};
